import React from "react"
import {
  Grid,
  Box,
  Heading as HeadingChakra,
  Text as ChakraText,
  Accordion,
  AccordionPanel,
  AccordionButton,
  AccordionItem,
  AccordionIcon,
} from "@chakra-ui/react"
import { SEO, Container, Text } from "@src/shared/components"
// Marketing components
import { PageLayout } from "@src/features/marketing/components"
import { useBuyButton } from "@src/shared/hooks"

// Ecommerce Components
import { ProductImages } from "@src/features/ecommerce/components"

const images = [
  {
    src: "https://res.cloudinary.com/djza4vnrm/image/upload/v1656099748/ohema/nyansapo/Nyansapo_style1_q1cadx.jpg",
    alt: "Nyansapo",
  },
  {
    src: "https://res.cloudinary.com/djza4vnrm/image/upload/v1656099748/ohema/nyansapo/Nyansapo_style2_mtgx1y.jpg",
    alt: "Nyansapo",
  },
  {
    src: "https://res.cloudinary.com/djza4vnrm/image/upload/v1655075745/ohema/nyansapo/Nyansapo_2_cpxg8q.jpg",
    alt: "Nyansapo",
  },
  {
    src: "https://res.cloudinary.com/djza4vnrm/image/upload/v1655075745/ohema/nyansapo/Unamed_1_woig00.jpg",
    alt: "Nyansapo",
  },
]

const Page: React.FC = () => {
  const elementId = "product-component-1656097426498"
  useBuyButton("7293010215087", elementId)

  return (
    <>
      <SEO
        title="Nyansapo Bracelet | Ohema"
        robots="index, follow"
        description="Add this dainty and elegant piece of jewelry to your collection and step into the queen you already are."
        keywords="African jewelry, Akan GoldWeights Bracelet"
        pathName="product/nyansapo"
        type="product"
        banner="images/nyansapo-og-image.jpeg"
        ldJSON={`
        {
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Nyansapo Bracelet",
          "image": "https://ohemabyeba.com/images/nyansapo-og-image.jpeg",
          "description": "Add this dainty and elegant piece of jewelry to your collection and step into the queen you already are.Coast",
          "brand": {
            "@type": "Thing",
            "name": "Ohema"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "CAD",
            "price": "40.00",
            "url" : "https://www.ohemabyeba.com/product/nyansapo/"
          }
        }
      `}
      />
      <PageLayout>
        <Container>
          <Grid
            gridTemplateColumns={{ sm: "1fr", md: "1fr", lg: "2fr 1fr" }}
            gridTemplateRows={{ sm: "1fr", md: "1fr", lg: "auto" }}
            columnGap="2rem"
          >
            <ProductImages images={images} />
            <Box>
              <Box position="sticky" top="0">
                <Box bg="white" p={5} height="auto">
                  <HeadingChakra as="h1" fontSize="1.875rem" color="#5C5C5C">
                    Nyansapo
                  </HeadingChakra>
                  <ChakraText mt={3} fontSize="1.125rem" fontWeight="light">
                    40 $CA
                  </ChakraText>
                  <Text type="small" mt={3}>
                    Our Akan goldweights collection features West African Akan
                    goldweights sourced directly from the Ivory Coast.
                  </Text>
                  <Text type="small" mt={2}>
                    In Akan society, gold was intimately associated with
                    authority, royalty, and the sacred. Akan goldweights are one
                    of the most popular pieces of Akan art. Traditionally made
                    of bronze, coper or brass and plated with a thin layer of
                    gold, they play a central part of West African jewelry,
                    conveying traditional wisdom through ornaments. The Nyansapo
                    goldweight is inspired by the Nyansapo (Wisdom knot) Adinkra
                    symbol which represents wisdom, intelligence and patience.
                  </Text>
                  <Text type="small" mt={2}>
                    Add this dainty and elegant piece of jewelry to your
                    collection and step into the queen you already are.
                  </Text>
                  <Box id={elementId} />
                </Box>
                <Accordion bg="#FFFCF7" mt={9}>
                  <AccordionItem>
                    <h2>
                      <AccordionButton py={3}>
                        <Box flex="1" textAlign="left">
                          <HeadingChakra
                            fontSize="0.875rem"
                            color="#5C5C5C"
                            fontWeight="regular"
                          >
                            Material
                          </HeadingChakra>
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                      goldweights: 14k gold-plated on bronze <br />
                      Chain: 14k gold plated on 925 silver sterling
                    </AccordionPanel>
                  </AccordionItem>

                  <AccordionItem>
                    <h2>
                      <AccordionButton py={3}>
                        <Box flex="1" textAlign="left">
                          <HeadingChakra
                            fontSize="0.875rem"
                            color="#5C5C5C"
                            fontWeight="regular"
                          >
                            Dimension
                          </HeadingChakra>
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                      <Text type="small" mt={2}>
                        Length: 15 cm/6 inches | 17.7 cm/7 inches
                      </Text>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              </Box>
            </Box>
          </Grid>
        </Container>
      </PageLayout>
    </>
  )
}

export default Page
